import './App.css';
// import Header from './Components/Header';
// import { Footer,Footer2 } from './Components/Footer';
// import Resturant from './Components/Basics/Resturant';
// import UseState from './Components/Hooks/UseState';
// import Login from './Components/Login&SignUp/Route';
import Netflix from './Components/Netflix/Route';
// import OOP from './Components/OOP/OOP';
// import Pokemon from './Components/Pokemon/Route';
// import Recipe from './Components/Recipe/Route';
// import Esewa from './Components/Esewa/Route';

function App() {
  return (
    <>
    {/* Header and Footer */}
    {/* <div className="App">
      <div className='body'>
          <Header name={"Pritam"} income={20000}/>
          <Header name={"Pritam1"} income={40000}/>
          <Header name={"Pritam2"} income={50000} />
        </div>
      <footer>
        <Footer name={"Pritam"}/>
        <Footer2 />
      </footer>
    </div> */}
    
    {/* Resturant Menu*/}
    {/* <div><Resturant/></div> */}

    {/* React Hooks */}
    {/* <UseState/> */}

    {/* Login and SignUp */}
    {/* <Login/> */}

    {/* Netflix Clone */}
    {<Netflix/>}

    {/* OOP Concept*/}
    {/* {<OOP/>} */}

    {/* Pokemon */}
    {/* {<Pokemon/>} */}

    {/* Recipe */}
    {/* {<Recipe/>} */}

    {/* Esewa */}
    {/* {<Esewa/>} */}
    </>
  );
}

export default App;
